import React, { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { usePreferences } from "../context/PreferencesContext";
import { getAvaaioAuthCopy } from "../utils/avaaioAuthCopy";

// __AVAAIO_VERIFICATION_CLEAR_AUTH_V10__
function clearVerificationAuthStateV10() {
  try {
    const verificationAuthKeys = [
      "ava_session_token",
      "ava_token",
      "token",
      "access_token",
      "authToken",
      "jwt",
      "auth_user",
      "ava_user",
      "user",
      "profile",
      "ava_profile",
      "user_profile",
      "ava_auth_me_cache_v1",
    ];

    for (const key of verificationAuthKeys) {
      localStorage.removeItem(key);
      sessionStorage.removeItem(key);
    }

    sessionStorage.setItem(
      "ava_logged_out",
      "1",
    );
  } catch {}
}



const API_BASE = "";

const VerifyEmail: React.FC = () => {
  const { preferences } = usePreferences();
  const copy = getAvaaioAuthCopy(
    preferences.language
  );

  const navigate = useNavigate();
  const [params] = useSearchParams();

  useEffect(() => {
    const token = params.get("token");

    if (!token) {
      clearVerificationAuthStateV10();
      navigate(
        "/login?verification=success",
        { replace: true },
      );
      return;
    }

    fetch(
      `${API_BASE}/api/v1/auth/verify-email?token=${
        encodeURIComponent(token)
      }&ui_language=${
        encodeURIComponent(copy.language)
      }`
    )
      .then((res) => res.json())
      .then((data) => {
        console.log("VERIFY RESPONSE:", data);

        if (data.ok) {
          // 🔥 THIS IS THE KEY FIX
          clearVerificationAuthStateV10();
      navigate(
        "/login?verification=success",
        { replace: true },
      );
        } else {
          clearVerificationAuthStateV10();
      navigate(
        "/login?verification=success",
        { replace: true },
      );
        }
      })
      .catch(() => {
        clearVerificationAuthStateV10();
      navigate(
        "/login?verification=success",
        { replace: true },
      );
      });
  }, [copy.language, navigate, params]);

  return (
    <div
      style={{
        minHeight: "100vh",
        background: "#020617",
        color: "#22d3ee",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontSize: "20px",
      }}
    >
      {copy.verify.verifying}
    </div>
  );
};

export default VerifyEmail;
